const LoadMoneyActionType = {
    SET_LOAD_AMOUNT_DETAIL:'SET_LOAD_AMOUNT_DETAIL'
  }
  export default LoadMoneyActionType;